import React, { Component } from 'react';

class EmailHistory extends Component {
  render() {
    return <div>EmailHistory</div>;
  }
}

export default EmailHistory;
